import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux'
import { Link } from 'react-router';
import StoryCard from './StoryCard';
import SharedStoryCard from '../sharedStory/SharedStoryCard';
import SharedStoryBtn from '../../components/SharedStoryBtn';
import StoryArchiveBtn from '../../components/StoryArchiveBtn';
import  Slider  from 'react-slick';
import { merge } from 'lodash/object';
import { concat } from 'lodash/array';

import { loadHomeStories, loadSharedStories } from '../../actions';




class HomeStories extends React.Component {

  constructor(props) {
    super(props);
  }


  componentWillMount() {
    this.props.loadHomeStories();
    this.props.loadSharedStories();
  }

  componentDidMount() {
    if (typeof(window) !== "undefined") {
      window.scrollTo(0,0)
    }
  }

  mergeStories = (homeStories, sharedStories) => {
    // Merge home stories with shared stories into allStories
    var allStories = homeStories.concat(sharedStories);
    return allStories;
  }

  sortStories = (allStories) => {
    // Sort homeStories by js_date which pulls from status_changed in backend
        allStories.sort(function(a, b){
          var dateA = a.js_date, dateB = b.js_date;
          if (dateA > dateB) {
            return -1;
          }
          if (dateA < dateB) {
            return 1;
          }
          return 0;
        });

        return allStories;
  }


  render() {

    if (!this.props.homeStories.isLoaded) {
      return <span />
    }

    if (!this.props.sharedStories.isLoaded) {
      return <span />
    }

    let allStories = this.mergeStories(this.props.homeStories, this.props.sharedStories);

    let sortedStories = this.sortStories(allStories);

    let storyList = '';
    storyList = sortedStories.map((story, index) => {
      if (index <= 14) {
        if (story.story_type == 'shared_story') {
          return <div className="homeStories-storyCardWrapper">
                      <SharedStoryCard
                        key={story.id}
                        sharedstory={story}
                        browser={this.props.browser}
                      />
                    </div>;
        } else if (story.story_type == 'news') {
          return <div className="homeStories-storyCardWrapper">
                      <StoryCard
                        key={story.id}
                        story={story}
                        browser={this.props.browser}
                      />
                    </div>;
        }
      }

    });

    return(
      <main>
        <div className="homeStories-outerWrapper">
          <section className="homeStories-wrapper">
            <h4 className="section-title">Leader Spotlight</h4>
            <div className="section-description">Be inspired by the women who lead organizations that empower women and girls around the world</div>

            <div className="homeStories-btnWrapper">
              <SharedStoryBtn />

              <StoryArchiveBtn />
            </div>

            <div className="homeStories-storyCardsInnerWrapper">

              {storyList}

            </div>

          </section>
        </div>

      </main>
    )
  }

};

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    push,
    loadHomeStories,
    loadSharedStories
 })(HomeStories);



// WEBPACK FOOTER //
// ./src/components/storyComponents/HomeStories.jsx